// extracted by mini-css-extract-plugin
export default {"profileSetting":"ProfileSetting_profileSetting__uGjfW","settingTabs":"ProfileSetting_settingTabs__+uIOe"};